'use strict';

var angular = require('angular');


module.exports = angular
	.module('flxShowThumb', [
		'timeService'
	])
	.directive('flxShowThumb', require('./flxShowThumbDirective'));